//==========================================================================
// forgot.js - Optimized Forgot Password Validation
//==========================================================================

(function ($) {

  $(function () {
    $("#forgotForm").validate({
      rules: {
        email: {
          required: true,
          email: true,
          maxlength: 100
        }
      },
      messages: {
        email: {
          required: "メールアドレスを入力してください。",
          email: "正しいメールアドレスの形式で入力してください。",
          maxlength: "メールアドレスは100文字以内で入力してください。"
        }
      },
      errorClass: 'c-form__error',
      errorPlacement: function (error, element) {
        error.insertAfter(element);
      },
      highlight: function (element) {
        $(element).addClass('c-form__input--error');
      },
      unhighlight: function (element) {
        $(element).removeClass('c-form__input--error');
      },
      submitHandler: function (form) {
        const submitButton = $(form).find('button[type="submit"]');
        const originalText = submitButton.find('.c-btn__detail-txt').text();
        submitButton.find('.c-btn__detail-txt').text('送信中...');
        submitButton.prop('disabled', true);

        setTimeout(function () {
          submitButton.find('.c-btn__detail-txt').text(originalText);
          submitButton.prop('disabled', false);
        }, 10000);

        return false;
      }
    });
  });

})(jQuery);